module.exports = __webpack_public_path__ + "img/vipEquityA.5b9a5154.png";